/* Plot & Harvest: keep the header basket count in step when ph-* sections change the cart (Horizon listens for @shopify/events, not cart:update) */
(function () {
  if (window.__phBridge) return; window.__phBridge = true;
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {}, n = d.data && typeof d.data.itemCount === 'number' ? d.data.itemCount : (d.resource && d.resource.item_count);
    if (typeof n !== 'number') return;
    document.querySelectorAll('cart-icon').forEach(function (ci) { if (typeof ci.renderCartBubble === 'function') ci.renderCartBubble(n); });
  });
})();
